import React from 'react';
import CountUp from 'react-countup';

import * as moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-BR');

const SectionDescription = (desc) => {
    return (<p>{desc}</p>);
}

const SectionTitle = ( args ) => {
    return (
        <div>
            <h2>{args.section}</h2>
            <h3>{args.subtitle} <strong>{args.featured}</strong></h3>
        </div>
    );
}

const BoxContentIcon = (arg, key) => {
    return(
        <div className={arg.col} key={key}>
            <div className="card card-default">
                <div className="card-body text-center">
                    <div className="icon">
                        <img src={process.env.PUBLIC_URL + `/assets/images/${arg.icon}.jpg`} alt={arg.icon} />
                    </div>
                    <h4>{arg.title}</h4>
                    <p>{arg.description}</p>                    
                </div>
            </div>            
        </div>
    )
}
const BoxContentProduct = (arg, key) => {
    return(
        <div className={arg.col} key={key}>
            <div className="card card-default">
                <a href={arg.url} target="_blank">
                    <img src={process.env.PUBLIC_URL + `/assets/images/${arg.img}.jpg`} alt={arg.img} />
                    <div className="box-title">
                        <h4>{arg.title}</h4>
                    </div>
                </a>
            </div>            
        </div>
    )
}
const BoxContentCounter = (arg, key) => {
    return(
        <div className={arg.col} key={key}>
            <div className="box-counter">
                <img src={process.env.PUBLIC_URL + `/assets/images/${arg.img}.png`} alt={arg.img} />
                <h3>{ arg.plus ? '+ ' : ''} <CountUp end={arg.n}  delay={5} duration={arg.duration} /> </h3>
                <h4>{arg.title}</h4>                
            </div>            
        </div>
    )
}
const BoxContentBlog = (arg,key) => {
    return(
        <div className={arg.col} key={key}>
            <div className="card card-default">
                <img src={process.env.PUBLIC_URL + `/assets/images/${arg.img}.jpg`} alt={arg.img} />     
                <div className="card-body">
                    <label htmlFor="">{arg.category}</label>
                    <h4>{arg.title}</h4>
                    <span className="date"><i className="fa fa-calendar" /> Data: {moment(arg.date).format('LL')}</span>
                    <span className="comments"><i className="fa fa-comments" /> ({arg.comments}) Comentário(s)</span>
                </div>           
            </div>            
        </div>
    )
}
const BoxContentTestimunials = (arg,key) => {
    return(
        <div className={arg.col} key={key}>
            <div className="card card-default">
                <div className="card-body">
                    <img src={process.env.PUBLIC_URL + `/assets/images/quote.jpg`} alt={'quote'} />
                    <h4>{arg.name} - <small>{arg.office}</small></h4>
                    <p>{arg.description}</p>
                </div>
            </div>            
        </div>
    )
}
const BoxContentCases = (arg,key) => {
    return(
        <div className={arg.col} key={key}>
            <div className="card card-default">
                <img src={process.env.PUBLIC_URL + `/assets/images/${arg.img}.jpg`} alt={arg.img} />     
                <div className="card-body">
                    <label htmlFor="">{arg.category}</label>
                    <h4>{arg.title}</h4>
                    <span className="maker"><i className="fa fa-map-marker" /> LOCAL: {arg.maker}</span>
                </div>           
            </div>            
        </div>
    )
}

export {
    SectionDescription,
    SectionTitle,
    BoxContentIcon,
    BoxContentProduct,
    BoxContentCounter,
    BoxContentBlog,
    BoxContentTestimunials,
    BoxContentCases
}